import { NewState } from "../../enums/NewState.enum";

export interface DeleteResult {
  id: number;
  messages: string[];
  success: boolean;
  newState: NewState;
}
